import { UpdateHelpSectionParams } from '@partnerconnect-monorepo/types/HelpSection';
import { Button } from '@partnerconnect-monorepo/ui/components/ui/button';
import {
  CardContent,
  CardFooter,
  CardHeader
} from '@partnerconnect-monorepo/ui/components/ui/card';
import { Input } from '@partnerconnect-monorepo/ui/components/ui/input';
import { T } from '@transifex/react';
import {
  Field,
  FieldError,
  FieldLabel
} from '@partnerconnect-monorepo/ui/components/ui/field';
import { RichTextEditor } from '@partnerconnect-monorepo/ui/components/composed/rich-text-editor';
import { Control, Controller } from 'react-hook-form';
import { t } from '@transifex/native';
import { OverlaySpinner } from '@partnerconnect-monorepo/ui/components/composed/overlay-spinner';

interface HelpSectionEditFormViewProps {
  control: Control<UpdateHelpSectionParams>;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
  isLoading: boolean;
}

export const HelpSectionEditFormView = ({
  control,
  onCancel,
  onSubmit,
  isLoading
}: HelpSectionEditFormViewProps) => (
  <>
    {isLoading && <OverlaySpinner />}
    <CardHeader className="flex justify-between items-baseline">
      <Controller
        control={control}
        name="title"
        rules={{ required: t('Title is required') }}
        render={({ field, fieldState }) => (
          <Field data-invalid={fieldState.invalid}>
            <FieldLabel>
              <T _str="Title" />
            </FieldLabel>
            <Input {...field} />
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
          </Field>
        )}
      />
    </CardHeader>
    <CardContent>
      <Controller
        control={control}
        name="body"
        rules={{ required: t('Body is required') }}
        render={({ field, fieldState }) => (
          <Field data-invalid={fieldState.invalid}>
            <FieldLabel>
              <T _str="Body" />
            </FieldLabel>
            <RichTextEditor {...field} content={field.value} />
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
          </Field>
        )}
      />
    </CardContent>
    <CardFooter className="justify-between">
      <Button variant="secondary" onClick={onCancel}>
        <T _str="Cancel" />
      </Button>
      <Button onClick={onSubmit}>
        <T _str="Save" />
      </Button>
    </CardFooter>
  </>
);
